import { useMemo } from "react";
import { useGetCountryCode } from "./useGetCountryCode";
import { getRegionConfig, DEFAULT_REGION, type RegionConfig } from "@src/features/settings/region-config";

export function useRegionConfig(): RegionConfig {
  const countryCode = useGetCountryCode();
  return useMemo(() => getRegionConfig(countryCode || DEFAULT_REGION), [countryCode]);
}
